import ImageStore from './ImageStore'

export default ImageStore
